exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".desc1[data-v-06faae8b]{color:#9a9a9a;font-size:12px}.point-payment-table td[data-v-06faae8b],.point-payment-table th[data-v-06faae8b]{text-align:center!important;font-size:12px;width:33.3%}.point-payment-table th[data-v-06faae8b]{font-weight:700;background-color:#f5f5f5}.input-title[data-v-06faae8b]{width:40px}input[type=text][data-v-06faae8b]{width:124px}", ""]);

// exports
